export default function useTestId(baseTestId) {
  const getTestId = (suffix = "", ignoreBaseTestId = false) => {
    if (baseTestId && suffix && !ignoreBaseTestId) {
      return `${baseTestId}-${suffix}`;
    }

    if (baseTestId && !ignoreBaseTestId) {
      return baseTestId;
    }

    return suffix;
  };

  return {
    getTestId,
  };
}
